import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('fieldBoundaryFields');

    return {
        MOVE: t('move'),
        REASSIGN_BOUNDARY_SUB_TEXT: ({
            boundaryName,
            fieldName
        }: {
            boundaryName: string;
            fieldName: string;
        }) => t('reassignBoundarySubText', { boundaryName, fieldName }),
        REASSIGN_BOUNDARY_TEXT: ({ boundaryName }: { boundaryName: string }) =>
            t('reassignBoundaryText', { boundaryName }),
        REMOVE: t('remove'),
        UNASSIGN_LAST_BOUNDARY_SUB_TEXT: t('unassignLastBoundarySubText'),
        UNASSIGN_PRIMARY_SUB_TEXT: t('unassignPrimarySubText'),
        UNASSIGN_PRIMARY_TEXT: ({ boundaryName }: { boundaryName: string }) =>
            t('unassignPrimaryText', { boundaryName }),
        UNKNOWN_FIELD: t('unknownField')
    };
};

export default useTranslation;
